<ng-container *ngIf="column">
  <miq-select
    #input
    class="filter--select"
    [currentValue]="currentValue"
    [values]="values$ | async"
    [placeholder]="state"
    [required]="column.required"
    [column]="column"
    (currentValueChange)="setCurrentValue($event)"
  >
  </miq-select>
</ng-container>
